
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[lang]/suche/branchen",
      function () {
        return require("private-next-pages/[lang]/suche/branchen.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[lang]/suche/branchen"])
      });
    }
  